const conditions = () => {
  return [
    // { projectType: { $ne: '' } },
    { assetClass: { $ne: '' } },
    {
      assetClass: {
        $in: {
          'object.asset-class.options.wohnen': 'object.object-type.living.options',
          'object.asset-class.options.handel-retail': 'object.object-type.commerce-and-retail.options',
          'object.asset-class.options.hotel': 'object.object-type.hotel.options',
          'object.asset-class.options.logistik-industrie': 'object.object-type.logistic.options',
          'object.asset-class.options.healthcare-medical': 'object.object-type.healthcare.options',
          'object.asset-class.options.micro-und-serviced-living': 'object.object-type.micro-and-serviced-living.options',
          'object.asset-class.options.freies-ankaufsprofil': 'object.object-type.free-selection.options',
        },
      },
    },
  ]
}

export default conditions
